import React, { useState, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable, { createTheme } from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import GetAppIcon from "@mui/icons-material/GetApp";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { downloadFile, getBillDetail, postBills } from "services/ConfigServices";
import { energyData, sources, consoUnitData, displayBillsColumnsData, billcanceled } from "variables/lists/bills";
import { billtext } from "variables/bills";
import useBillsTable from "./useBillsTable.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import ViewSubBillDialog from "./ViewSubBillDialog.js";
import EditEtatPaiementDialog from "./EditEtatPaiementDialog.js";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import ReactLoading from "react-loading";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import { NotificationManager } from "react-notifications";
import "./table.css";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
  color: grey;
`;
const LoadingDiv = styled.div`
height: 20vh;
width: 20vw;
display: flex;
flex-wrap: nowrap;
align-content: center;
justify-content: center;
padding-top: 10vh;
`;

const Container = styled.div`
  border: solid;
  border-width: 1px;
  border-color: #EEEEEE;
  background-color: white;
  margin-top: -0.5px;
  padding-top: 5px;
  overflow-x: auto;
  width: 100%;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

createTheme('solarized', {
  text: {
    primary: '#000000',
    secondary: '#000000',
  },
  background: {
    default: '#e6e5eb',
  },
  context: {
    background: '#e6e5eb',
    text: '#000000',
  },
  divider: {
    default: '#FFFFFF',
  },
  action: {
    button: 'rgba(0,0,0,.54)',
    hover: 'rgba(0,0,0,.08)',
    disabled: 'rgba(0,0,0,.12)',
  },
}, 'dark');


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);




const downloadGED = (fileId, fileName) => async () => {
  axios
    .get(
      downloadFile(fileId, 'import'),
      {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      }
    )
    .then((response) => {
      console.log(response);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      console.log(url);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", response.headers.avobfilename); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
};


const useStyles = makeStyles(styles);

const useStyles2 = makeStyles((theme) => ({
  table: {
    "& .bINImG": {
      display: "block",
    },
  },
}));

const RTBills = () => {
  const currentusertype = localStorage.getItem('userType');
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const bills_admin = permis.includes("bills_admin");
  const { gridState, refetch, setSelectedBills, displaymethod } = useBillsTable();
  const [openSubBill, setOpenSubBillStatus] = useState(false);
  const [subbill, setSubbill] = useState(null);
  const [openBill, setOpenBill] = useState(false);
  const [bill, setBill] = useState(null);

  const classes = useStyles();

  const viewSubBill = (row) => async () => {
    console.log(row);
    handleViewSubBillOpen();
    axios
      .get(
        getBillDetail(row.id),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          console.log(res);
          setSubbill(res.data);
        }
      });
  };


  const subcolumnbypdl = (exportarray, energy) => {

    let columns = displayBillsColumnsData[energy].map((item) => {
      let column = {
        name: item.name,
        selector: (row) => row[item.id] ? Number(row[item.id]) : 0,
        sortable: true,
        maxWidth: "10rem",
        cell: (row) => row[item.id] ? new Intl.NumberFormat('fr-FR').format(row[item.id]) : ''
      };
      return column;
    });

    columns.unshift(
      {
        name:
          <UploadButton type="button">
            <ExportTableToCSV dataarray={exportarray} />
          </UploadButton>,
        sortable: false,
        width: currentusertype == 1 ? "12rem" : "8rem",
        cell: (row) => (
          <>
            <div className="actions-right">
              { currentusertype == 1 ?
                 <Tooltip title="Supprimer la facture">
                 <CustomDeleteButton
                   deleteTitle={"Suppression de la facture"}
                   deleteSubTitle={`Êtes-vous sûr de vouloir supprimer la facture ${row.docreference}? ATTENTION : cette action supprimera uniquement la facture mais ne supprimera pas les données.`}
                   handleSupprimer={deleteBillFunction(row)}
                 />
               </Tooltip> : <></>
              }
              {row.fileid ?
                <Tooltip title="Télécharger la facture">
                  <Button
                    onClick={downloadGED(row.fileid, row.fileid)}
                    color={"info"}
                    className={classes.actionButton}
                  >
                    <GetAppIcon fontSize="large" />
                  </Button>
                </Tooltip> : <></>}
              <Tooltip title="Détails">
                <Button
                  onClick={viewSubBill(row)}
                  color={"info"}
                  className={classes.actionButton}
                >
                  <VisibilityIcon fontSize="large" />
                </Button>
              </Tooltip>

            </div>
          </>
        ),
      },
      {
        name: "PDL",
        selector: (row) => row.pdl,
        sortable: true,
        width: "9rem",
        cell: (row) => row.pdl,
      },
      {
        name: "Date de facture",
        selector: (row) => row.billdate,
        sortable: true,
        maxWidth: "10rem",
        cell: (row) =>
          row.billdate && moment(row.billdate).isValid()
            ? moment(row.billdate).format("DD/MM/YYYY")
            : "",
      },
      {
        name: "N° de facture",
        selector: (row) => row.docreference,
        sortable: true,
        width: "9rem",
        cell: (row) => row.docreference,
      },
      {
        name: "Date de début",
        selector: (row) => row.begin,
        sortable: true,
        maxWidth: "10rem",
        cell: (row) =>
          row.begin && moment(row.begin).isValid()
            ? moment(row.begin).format("DD/MM/YYYY")
            : "",
      },
      {
        name: "Date de fin",
        selector: (row) => row.end,
        sortable: true,
        maxWidth: "10rem",
        cell: (row) =>
          row.end && moment(row.end).isValid()
            ? moment(row.end).format("DD/MM/YYYY")
            : "",
      });

    return columns;
  }
  const ExpandableComponent = props => {
    const { data } = props;
    // const datadisplay = data.pdlBills.map((item) => {
    //   let datapdl = { ...item };
    //   datapdl.energy = data.energy;
    //   if (datapdl.rawdata) {
    //     datapdl.rawdata.map((itemdata) => {
    //       datapdl[itemdata.key] = itemdata.value;
    //     });
    //   }
    //   return datapdl;
    // });
    const datadisplay = data.pdlBills.map((item) => {
      let datapdl = { ...item };
      datapdl.energy = data.energy;
      if (datapdl.rawdata) {
        datapdl.rawdata.map((itemdata) => {
          if(itemdata.value)
          {
            if (datapdl[itemdata.key])
            {
              datapdl[itemdata.key] += Number((""+itemdata.value).replace(",", "."));
            }
            else
            {
              datapdl[itemdata.key] = Number((""+itemdata.value).replace(",", "."));
            }
             
          }
          if (moment(itemdata.begindate).isBefore(moment(datapdl.begin)))
            datapdl.begin = itemdata.begindate;
          if (moment(itemdata.enddate).isAfter(moment(datapdl.end)))
            datapdl.end = itemdata.enddate;
        });
      }
      console.log(datapdl);
      return datapdl;
    });
    // const datadisplay = data.pdlBills.map((item) => {
    //   let datapdl = { ...item };
    //   datapdl.energy = data.energy;
    //   console.log(datapdl.groupedrawdata);
    //   if (datapdl.groupedrawdata) {
    //     datapdl.groupedrawdata.each((key) => {
    //       datapdl[key] = datapdl.groupedrawdata[key];
    //     });
    //   }
    //   console.log(datapdl);
    //   return datapdl;
    // });
    // console.log(data);
    let exportarray = datadisplay.map((row) => {
      let billtoexport = {};
      billtoexport[billtext.pdl] = row.pdl;
      billtoexport[billtext.energy] = energyData.find((x) => x.id == data.energy)?.name;
      billtoexport[billtext.sender] = data.sender;
      billtoexport[billtext.docreference] = row.docreference;
      billtoexport[billtext.billdate] = (row.billdate && moment(row.billdate).isValid()) ? moment(row.billdate).format("DD/MM/YYYY") : "";
      billtoexport[billtext.begindate] = (row.begin && moment(row.begin).isValid()) ? moment(row.begin).format("DD/MM/YYYY") : "";
      billtoexport[billtext.enddate] = (row.end && moment(row.end).isValid()) ? moment(row.end).format("DD/MM/YYYY") : "";
      billtoexport[billtext.billstate] = (row.billcanceled && row.billcanceled == 1) ? billcanceled.find((x) => x.id == 'canceled')?.name : billcanceled.find((x) => x.id == 'validated')?.name;
      displayBillsColumnsData[data.energy].map((column) => {
        // newrow[header.field] = ('' + newrow[header.field]).replace('.', ',');
        billtoexport[column.name] = row[column.id] ? ('' + row[column.id]).replace('.', ',').replace(' ', '') : '';
        //billtoexport[column.name] = row[column.id] ? new Intl.NumberFormat('fr-FR').format(row[column.id]) : '';
      });
      return billtoexport;
    });

    //  console.log(exportarray);

    return (
      <Container>
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          noDataComponent={<NoData>Aucun PDL à afficher</NoData>}
          noHeader={true}
          columns={subcolumnbypdl(exportarray, data.energy)}
          persistTableHead
          data={datadisplay}
          striped={true}
          conditionalRowStyles={conditionalRowStyles}
        //theme="solarized"
        />
      </Container>
    );
  };

  const conditionalRowStyles = [
    {
      when: row => row.billcanceled == 1,
      style: {
        backgroundColor: '#F44336',
        color: 'white',
      },
    },
  ];
  const conditionalRowStylesGroup = [
    {
      when: row => row.billcanceled == 1,
      style: {
        backgroundColor: '#FF763A',
        color: 'white',
      },
    },
  ];

  const deleteBillFunction = (row) => async () => {
    let deletearray = [];
    deletearray.push(row);
    let url = postBills("delete");
    axios
      .post(url,
        {
          bills : deletearray
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `La facture a été supprimée`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };
  const editEtatPaiement = (row) => async () => {
    console.log(row);
    setBill(row);
    handleViewBillOpen();
  };

  const columnsBydocref = [
    {
      name: "Energie",
      key : "energy",
      selector: (row) => row.energy,
      sortable: false,
      maxWidth: "9rem",
      cell: (row) => row.energy ?
        <div>
          {energyData.find((x) => x.id == row.energy)?.name}
        </div> : <></>
    },
    {
      name: "Fournisseur",
      key : "sender",
      selector: (row) => row.sender,
      sortable: true,
      maxWidth: "13rem",
      cell: (row) => row.sender
    },
    {
      name: "Source",
      key : "source",
      selector: (row) => row.source,
      sortable: true,
      maxWidth: "9rem",
      cell: (row) => row.source ?
        <div>
          {sources.find((x) => x.id == row.source)?.name}
        </div> : <></>
    },
    {
      name: "N° de facture",
      key : "docreference",
      selector: (row) => row.docreference,
      sortable: true,
      maxWidth: "13rem",
    },
    {
      name: "Date de facture",
      key : "billdate",
      selector: (row) => row.billdate,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        row.billdate && moment(row.billdate).isValid()
          ? moment(row.billdate).format("DD/MM/YYYY")
          : "",
    },
    {
      name: "Date de début",
      key : "begin",
      selector: (row) => row.begin,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        row.begin && moment(row.begin).isValid()
          ? moment(row.begin).format("DD/MM/YYYY")
          : "",
    },
    {
      name: "Date de fin",
      key : "end",
      selector: (row) => row.end,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        row.end && moment(row.end).isValid()
          ? moment(row.end).format("DD/MM/YYYY")
          : "",
    },
    {
      name: "Consommation",
      key : "conso",
      selector: (row) => row.conso,
      sortable: false,
      maxWidth: "10rem",
      cell: (row) => new Intl.NumberFormat('fr-FR').format(row.conso) + ' ' + consoUnitData.find((x) => x.id == row.energy)?.name
    },
    {
      name: "Montant € TTC",
      key : "ttc",
      selector: (row) => row.ttc,
      sortable: false,
      maxWidth: "10rem",
      cell: (row) => new Intl.NumberFormat('fr-FR').format(row.ttc)
    },
    {
      name: "Nombre de PDL", 
      key : "pdlBills",
      selector: (row) => row.pdlBills,
      sortable: false,
      maxWidth: "6rem",
      cell: (row) =>
        row.pdlBills.length,
    },
    {
      name: "",
      sortable: false,
      width: "10rem",
      omit: (currentusertype != 1 && !UserService.getEmail().endsWith('@besancon.fr') && !UserService.getEmail().endsWith('@grandbesancon.fr')),
      cell: (row) => (
        <>
          <div className="actions-right">
            {
              bills_admin &&
              <Tooltip title="Etat de paiement">
                <Button
                  onClick={editEtatPaiement(row)}
                  color={"info"}
                  className={classes.actionButton}
                >
                  <GetAppIcon fontSize="large" />
                </Button>
              </Tooltip>
            }
          </div>
        </>
      ),
    },
  ];

  const columnsByPDL = [
    {
      name: "PDL",
      selector: (row) => row.pdl,
      sortable: true,
      maxWidth: "13rem",
    },
    {
      name: "Energie",
      selector: (row) => row.energy,
      sortable: false,
      maxWidth: "9rem",
      cell: (row) => row.energy ?
        <div>
          {energyData.find((x) => x.id == row.energy)?.name}
        </div> : <></>
    },
    {
      name: "Fournisseur",
      selector: (row) => row.sender,
      sortable: true,
      maxWidth: "13rem",
    },
    {
      name: "Source",
      selector: (row) => row.source,
      sortable: true,
      maxWidth: "9rem",
      cell: (row) => row.source ?
        <div>
          {sources.find((x) => x.id == row.source)?.name}
        </div> : <></>
    },
    {
      name: "Date de début",
      selector: (row) => row.begin,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        row.begin && moment(row.begin).isValid()
          ? moment(row.begin).format("DD/MM/YYYY")
          : "",
    },
    {
      name: "Date de fin",
      selector: (row) => row.end,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        row.end && moment(row.end).isValid()
          ? moment(row.end).format("DD/MM/YYYY")
          : "",
    },
    {
      name: "Consommation",
      selector: (row) => row.conso,
      sortable: false,
      maxWidth: "10rem",
      cell: (row) => new Intl.NumberFormat('fr-FR').format(row.conso) + ' ' + consoUnitData.find((x) => x.id == row.energy)?.name
    },
    {
      name: "Montant € TTC",
      selector: (row) => row.ttc,
      sortable: false,
      maxWidth: "10rem",
      cell: (row) => new Intl.NumberFormat('fr-FR').format(row.ttc)
    },
    {
      name: "Nombre de factures",
      selector: (row) => row.pdlBills,
      sortable: false,
      //maxWidth: "6rem",
      cell: (row) =>
        row.pdlBills.length,
    },
    // {
    //   name: "",
    //   sortable: false,
    //   width: "10rem",
    //   omit: (currentusertype!=1 && !UserService.getEmail().endsWith('@besancon.fr')),
    //   cell: (row) => (
    //     <>
    //       <div className="actions-right">
    //         {
    //           bills_admin &&
    //             <Tooltip title="Etat de paiement">
    //               <Button
    //                 onClick={editEtatPaiement(row)}
    //                 color={"info"}
    //                 className={classes.actionButton}
    //               >
    //                 <GetAppIcon fontSize="large" />
    //               </Button>
    //             </Tooltip>
    //         }
    //       </div>
    //     </>
    //   ),
    // },
  ];

  const handleViewBillOpen = () => {
    setOpenBill(true);
  };
  const handleViewBillClose = () => {
    setOpenBill(false);
  };

  const handleViewSubBillOpen = () => {
    setOpenSubBillStatus(true);
  };
  const handleViewSubBillClose = () => {
    setOpenSubBillStatus(false);
  };

  const handleSelectedRowsChange = (selection) => {
    setSelectedBills(selection.selectedRows);
  };

  const classes2 = useStyles2();
  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucune facture à afficher</NoData>}
        // noHeader={true}
        title="Factures"
        columns={displaymethod === "docreference" ? columnsBydocref : displaymethod === "pdl" ? columnsByPDL : columnsBydocref}
        persistTableHead
        pagination
        paginationServer
        paginationPerPage={10}
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        subHeader
        progressPending={gridState.loading}
        progressComponent={<div><LoadingDiv><ReactLoading
          type={"bars"}
          color={"#91c241"}
          height={"10%"}
          width={"10%"}
        /></LoadingDiv></div>}
        //highlightOnHover
        //pointerOnHover
        expandOnRowClicked
        expandableRows
        expandableRowDisabled={(row) => row.disabled}
        expandableRowsComponent={ExpandableComponent}
        conditionalRowStyles={conditionalRowStylesGroup}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleViewSubBillClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openSubBill}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleViewSubBillClose}>
          Détails de la facture
        </CustomDialogTitle>
        <DialogContent dividers>
          <ViewSubBillDialog
            subbill={subbill}
            closeModal={handleViewSubBillClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleViewBillClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openBill}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleViewBillClose}>
          Création d'un état de paiement
        </CustomDialogTitle>
        <DialogContent dividers>
          <EditEtatPaiementDialog
            bill={bill}
            closeModal={handleViewBillClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTBills;
